export default __webpack_public_path__ + "static/avatar-04-77c92b2e4c77e4c6ce8e823fc0a09939.svg";